import { getClient } from '@epilot/file-client'

import { getConfig } from '../EnvConfig'

let client: ReturnType<typeof getClient>

export const getFilesClient = (orgId: string): ReturnType<typeof getClient> => {
  if (!client) {
    client = getClient()

    client.defaults.baseURL = getConfig().FILE_API_URL
    client.defaults.headers.common['x-epilot-org-id'] = orgId

    return client
  }

  return client
}
